module.exports = __webpack_public_path__ + "8d7a2fe1cfbd5f8866db0bb8f6dbd488.pdf";